import "./HorizontalScrollCarousel.css";

import React, { useRef, useEffect, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Link } from "react-router-dom";
import { ButtonDrawOutline } from "../../../../components/common";

const HorizontalScrollCarousel = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  let targetRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: targetRef,
  });

  const expand = useTransform(scrollYProgress, [0, 1], [1, 2]);
  const x = useTransform(scrollYProgress, [0, 1], ["43%", "-41%"]);

  // Update isMobile state on window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section
      ref={targetRef}
      className="lg:relative lg:w-[300vw] lg:h-[300vh] bg-gradient-to-r from-green-500 to-teal-900"
    >
      <div className={`text-white  lg:top-0 flex lg:h-screen w-full items-center ${isMobile ? "":"sticky overflow-hidden"} `}>
        <motion.div
          style={isMobile ? {} : { x }} // Disable horizontal scroll on mobile
          className={`flex ${isMobile ? "flex-col space-y-10" : "space-x-60"}`} // Switch to vertical layout on mobile
        >
          <div 

            class=" lg:w-1/2 float-left  box-border w-screen p-10  flex-1 grid items-center"
          >
            <h1 class="my-10 text-4xl lg:text-6xl  mb-5 ">
              Beyond Rescue: Uncover INSERR's Advanced ROVs Tailored to Your
              Underwater Needs{" "}
            </h1>
            <p class="text-lg text-justify lg:text-2xl ">
              A highly modular Remotely Operated Vehicle (ROV) designed for a wide range of applications, including ROV competitions,
              educational purposes, and research projects in both high schools
              and universities. Its flexibility also makes it an excellent
              choice for makers aiming to build advanced ROVs. Key features
              include a modular design, CAN bus and USB interfaces for electronics
              integration, and standard mounting options, allowing for easy
              customization and expansion to meet diverse project requirements.{" "}
            </p>
          </div>

          <motion.div
            className="box-right text-white"
            style={isMobile ? {} : { scale: expand }} // Disable scaling on mobile
          >
            <img
              src={require("../../../../assets/img/inserr/inserr_nobg_front.png")}
              alt="INSERR"

              class="h-[45vh] w-auto lg:w-[35vw]"
            />
          </motion.div>


          <div class="lg:w-1/2 float-left  box-border w-screen p-10  flex-1 grid items-center">
            <h2 class="my-10 text-4xl lg:text-6xl  mb-5 text-center">
              AquaROV
            </h2>
            <p class="text-lg text-justify mb-10">
              A highly modular Remotely Operated Vehicle (ROV) designed to cater to a wide range of applications, including ROV competitions, educational purposes, and research projects in both high schools and universities. Its flexibility also makes it an excellent choice for makers aiming to build advanced ROVs. Key features include a modular design, CAN bus and USB interfaces for electronics integration, and standard mounting options, allowing for easy customization and expansion to meet diverse project requirements. 
            </p>
            <Link
              to={"/inserr"}
              className="text-center bg-transparent py-2 px-4 mb-5"
            >
              <ButtonDrawOutline>Learn More About AquaROV →</ButtonDrawOutline>
            </Link>
          </div>
          <div class="lg:w-1/2 float-left  box-border w-screen p-10  flex-1 grid items-center">
            <h2 class="my-10 text-4xl lg:text-6xl  mb-5 text-center">
              AquaAUV
            </h2>
            <p class="text-lg text-justify mb-10">
            AquaAUV is an autonomous underwater vehicle designed for advanced research and exploration. Building upon the modular framework of INSERR, it offers enhanced capabilities for autonomous missions. Ideal for universities and research institutions, AquaAUV supports complex data collection and analysis in various underwater environments. Its modular design allows for easy integration of specialized sensors and equipment, catering to diverse research needs. 
            </p>
            <Link
              to={"/inserr"}
              className="text-center bg-transparent py-2 px-4 mb-5"
            >
              <ButtonDrawOutline>Learn More About AquaAUV →</ButtonDrawOutline>
            </Link>
          </div>
          <div class="lg:w-1/2 float-left  box-border w-screen p-10  flex-1 grid items-center">
            <h2 class="my-10 text-4xl lg:text-6xl  mb-5 text-center">
              AquaInspector 
            </h2>
            <p class="text-lg text-justify mb-10">
              AquaInspector is a specialized Remotely Operated Vehicle (ROV) designed for efficient and thorough hull inspections of shipping vessels. Equipped with high-resolution imaging sonar and advanced navigation systems, it enables operators to conduct comprehensive surveys even in challenging underwater conditions. AquaInspector's modular design allows for easy integration of additional sensors and tools, enhancing its adaptability to various inspection requirements. By utilizing AquaInspector, shipping companies can perform regular hull assessments to monitor structural integrity, detect biofouling, and identify potential maintenance needs, thereby ensuring vessel safety as well as optimizing for performance and cost-savings. 
            </p>
            <Link
              to={"/inserr"}
              className="text-center bg-transparent py-2 px-4 mb-5"
            >
              <ButtonDrawOutline>Learn More About AquaInspector →</ButtonDrawOutline>
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default HorizontalScrollCarousel;